import { render, staticRenderFns } from "./FormList.vue?vue&type=template&id=30ac04de&scoped=true"
import script from "./FormList.vue?vue&type=script&lang=ts"
export * from "./FormList.vue?vue&type=script&lang=ts"
import style0 from "./FormList.vue?vue&type=style&index=0&id=30ac04de&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ac04de",
  null
  
)

export default component.exports